var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { useSearchWizardStore } from '#imports';
import { Component, Prop, Vue } from 'vue-property-decorator';
var FilterAndSortLocation = (_dec = Component({
  setup() {
    var searchWizardStore = useSearchWizardStore(usePinia());
    return {
      searchWizardStore
    };
  }
}), _dec2 = Prop(), _dec3 = Prop({
  required: true
}), _dec4 = Prop(), _dec5 = Prop(), _dec(_class = (_class2 = class FilterAndSortLocation extends Vue {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "hierarchyPath", _descriptor, this);
    _initializerDefineProperty(this, "facetCounts", _descriptor2, this);
    _initializerDefineProperty(this, "isPriceSearch", _descriptor3, this);
    _initializerDefineProperty(this, "hierarchyTree", _descriptor4, this);
  }
  selectHierarchy(node) {
    var _this = this;
    return _asyncToGenerator(function* () {
      _this.$emit('changed', node.path);
      _this.$bubble('hierarchy', node.path);
      yield _this.$nextTick();
      _this.scrollToHierarchy();
    })();
  }
  shouldShowLocation(path) {
    // always show locations above our current path regardless of counts
    if (this.hierarchyPath.startsWith(path)) {
      return true;
    }
    // if not showing counts then show all
    if (!this.searchWizardStore.showCount) {
      return true;
    }
    // if lower then show if we have a count
    return !!this.facetCounts[path] || path === '/';
  }
  scrollToHierarchy() {
    this.$puScrollTo('[data-filter-location-scroll-target]', {
      duration: 300,
      offset: 0
    });
  }
  showCounts(path) {
    if (!this.searchWizardStore.showCount) {
      return false;
    }
    // show counts below us
    return this.facetCounts[path] ? true : path.startsWith(this.hierarchyPath);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "hierarchyPath", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "facetCounts", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "isPriceSearch", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "hierarchyTree", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
export { FilterAndSortLocation as default };